import { Grid, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getBanners } from "../../../services/BannerServices";
export const Banners = () => {
  const [banners, setBanners] = useState(null);
  useEffect(() => { (async () => { const res = await getBanners(); if (res) setBanners(res.map(i => ({ ...i, imagen: `${process.env.REACT_APP_URL_BACKEND}${i.imagen}` }))); })(); }, []);
  if (!banners) return null;
  return (
    <Box sx={{ width: '100%', maxWidth: 'var(--container-max)', mx: 'auto', px: { xs: 2, md: 3 } }}>
      <Grid container spacing={{ xs: 1.5, md: 2 }}>
        {banners.map((b, i) => (
          <Grid item key={i} xs={b.columnas_estilo * 3}>
            <Box sx={{ borderRadius: 'var(--radius-md)', overflow: 'hidden', transition: 'all 0.3s ease', boxShadow: 'var(--shadow-xs)', '&:hover': { boxShadow: 'var(--shadow-md)', transform: 'translateY(-2px)' } }}>
              {b.url ? <a href={b.url.startsWith('http') ? b.url : `https://${b.url}`} target={b.target === false ? "_self" : "_blank"} rel={b.target === "_self" ? undefined : "noopener noreferrer"} style={{ display: 'block' }}><img src={b.imagen} alt={b.descripcion || "banner"} style={{ width: '100%', display: 'block', cursor: 'pointer' }} /></a> : <img src={b.imagen} alt={b.descripcion || "banner"} style={{ width: '100%', display: 'block' }} />}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export default Banners;
